export default __webpack_public_path__ + "static/media/weatherDashboard.d28ebdcd.png";